<script setup lang="ts">
defineProps<{
  icon: string;
  title: string;
}>();
</script>

<template>
  <div class="d-flex align-center">
    <div class="section-header">
      <v-icon
        :icon="icon"
        color="primary"
        size="small"
        class="mr-2"
      />
      <span class="text-overline text-medium-emphasis section-header-text">
        {{ title }}
      </span>
      <v-divider class="ml-3" />
    </div>
    <slot />
  </div>
</template>

<style scoped>
.section-header {
  display: flex;
  align-items: center;
  flex: 1;
}

.section-header-text {
  white-space: nowrap;
}
</style>
